export default () => ({
    editableCell: {
        position: 'relative',
        overflow: 'visible',
        padding: '0 8px',
        '& > *': {
            flex: 1,
            position: 'relative',
        },
        // Keep validation message from shifting the input when it appears
        '& [class*="FieldBottom-root"]': {
            position: 'absolute',
            left: 0,
            right: 0,
            top: '100%',
            marginTop: 2,
            zIndex: 10,
            pointerEvents: 'none',
        },
    },
    right: {},
    switchCell: {
        display: 'flex',
        padding: '15px 0 10px 0',
        alignItems: 'center',
    },
});
